import React, { useEffect, useState } from "react";
import { useDarkMode } from "usehooks-ts";
import Logo from "../../assets/images/sidebarLogo.png";
import { ReactComponent as SearchIcon } from "../../assets/icons/search.svg";
import { ReactComponent as MenuIcon } from "../../assets/icons/menu.svg";
import { ReactComponent as MenuIcon2 } from "../../assets/icons/menu2.svg";

import { ReactComponent as MoonIcon } from "../../assets/icons/moon.svg";
import { ReactComponent as SunIcon } from "../../assets/icons/sun.svg";
import { ReactComponent as Close } from "../../assets/icons/close.svg";
import { ReactComponent as Home } from "../../assets/icons/home.svg";
import { ReactComponent as Live } from "../../assets/icons/live.svg";
import { ReactComponent as Pair } from "../../assets/icons/liveexplorer.svg";
import { AnimatePresence, motion } from "framer-motion";
import { Link, NavLink, useLocation } from "react-router-dom";
import Menu from "../../assets/images/menu.png";
import BitChain from "../../assets/images/LogoImg.png";
import PayWing from "../../assets/images/paywing.png";

import "./Navigation.scss";
import Dropdown from "../Dropdown";
import Loogo from "../../assets/images/logo.png";

import styled from "styled-components";

const Button = styled.button`
  color: #ffba00;
  font-size: 16px;
  padding: 10px 20px;
  border-radius: 20px;
  margin-right: 10px;
  cursor: pointer;
  border: none;
  box-shadow: 0px 3px 10px rgba(0, 0, 0, 0.2); /* Add a subtle box shadow */
  transform: translateY(0px); /* Reset the translateY */
  transition: transform 0.2s, box-shadow 0.2s; /* Add smooth transition effects */
`;

const Navigation: React.FC = () => {
  const { isDarkMode, toggle } = useDarkMode();
  const [openClose, setOpenClose] = useState(false);
  const [openCloses, setOpenCloses] = useState(false);

  const [activeLink, setActiveLink] = useState("");
  const [openDropdown, setOpenDropdown] = useState(false);
  const location = useLocation();

  // Get the current location using useLocation hook

  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    // Get the current URL pathname
    const currentUrlPathname = window.location.pathname;

    // Set the active link based on the current URL pathname
    setActiveLink(currentUrlPathname);
  }, []);

  useEffect(() => {
    if (openClose) {
      document.body.style.overflowY = "hidden";
      document.body.style.height = "100vh";
    } else {
      document.body.style.overflowY = "initial";
      document.body.style.height = "initial";
    }
  }, [openClose]);

  useEffect(() => {
    if (isDarkMode) {
      if (document.body.classList.contains("light")) {
        document.body.classList.remove("light");
      }
      document.body.classList.add("dark");
    } else {
      if (document.body.classList.contains("dark")) {
        document.body.classList.remove("dark");
      }
      document.body.classList.add("light");
    }
  }, [isDarkMode]);

  const [activeSection, setActiveSection] = useState("home");

  useEffect(() => {
    const sections = [
      "about",
      "tokenomics",
      "work",
      "roadmap",
      "team",
      "partners",
    ]; // Add more section IDs if needed
    const observer = new IntersectionObserver(
      (entries) => {
        let foundActive = false;

        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setActiveSection(entry.target.id);
            foundActive = true;
          }
        });

        // Default to "home" only if no other section is active
        if (!foundActive) {
          setActiveSection("home");
        }
      },
      {
        root: null, // Viewport as the container
        rootMargin: "0px", // No margin
        threshold: 0.5, // Adjust as needed
      }
    );

    sections.forEach((id) => {
      const target = document.getElementById(id);
      if (target) observer.observe(target);
    });

    return () => {
      sections.forEach((id) => {
        const target = document.getElementById(id);
        if (target) observer.unobserve(target);
      });
    };
  }, []);

  document.addEventListener("scroll", () => {
    const navigation = document.querySelector(".navigation-wrapper")!;
    if (window.scrollY > 0) {
      navigation.classList.add("scrolled");
    } else {
      navigation.classList.remove("scrolled");
    }
  });

  return (
    <div className="navigation-wrappers">
      <div className="desktopheadk">
        <div> </div>
        <div className="site-navs">
          {" "}
          <nav className="site-navigation">
            <ul className="nav">
              <li>
                <a
                  href="https://godriveauto.ca/about"
                  className={`navlinkssss ${
                    activeSection === "about" ? "active" : ""
                  }`}
                  onClick={() => {
                    const section = document.querySelector("about");
                    section?.scrollIntoView({ behavior: "smooth" });
                  }}
                >
                  About Us
                </a>
              </li>

              <li>
                <a
                  href="https://forms.gle/bxfoqbz6zqAdSez66"
                  className={`navlinkssss ${
                    activeSection === "home" ? "active" : ""
                  }`}
                >
                  Help Center
                </a>
              </li>
              {/* <li>
      <Link
    to="./#ecosystem"
    className={`navlink ${activeSection === "ecosystem" ? "active" : ""}`}
    onClick={() => {
      const section = document.querySelector("./#ecosystem");
      section?.scrollIntoView({ behavior: "smooth" });
    }}
  >
    Ecosystem
  </Link>
      </li> */}

              {/* <li>
                  <Link
                    to="./#partners"
                    className={`navlink ${
                      activeSection === "partners" ? "active" : ""
                    }`}
                    onClick={() => {
                      const section = document.querySelector("#partners");
                      section?.scrollIntoView({ behavior: "smooth" });
                    }}
                  >
                    Partners
                  </Link>
                </li> */}
            </ul>
          </nav>
        </div>
      </div>

      <div className="mobileheads topo">
        <div> </div>
        <div
          style={{
            display: "flex",
            gap: "0px",
            alignItems: "center",
            listStyle: "none",
            padding: "0px 0px",
            justifyContent: "end",
            marginTop: 5,
            marginRight: 0,
            borderRadius: "8px",
          }}
        >
          <li style={{ listStyle: "none", width: "fit-content" }}>
            <a
              href="https://godriveauto.ca/about"
              onClick={() => {
                const section = document.querySelector("about");
                section?.scrollIntoView({ behavior: "smooth" });
              }}
              style={{
                textDecoration: "none",
                color: "#fff",
                fontWeight: "500",
                padding: "8px 12px",
                borderRadius: "6px",
                transition: "all 0.3s",
              }}
              onMouseOver={(e) => {
                (e.target as HTMLElement).style.backgroundColor = "transparent";
              }}
              onMouseOut={(e) => {
                (e.target as HTMLElement).style.backgroundColor = "transparent";
              }}
            >
              About Us
            </a>
          </li>

          <li style={{ listStyle: "none", width: "fit-content" }}>
            <a
              href="https://forms.gle/bxfoqbz6zqAdSez66"
              style={{
                textDecoration: "none",
                color: "#fff",
                fontWeight: "500",
                padding: "8px 12px",
                borderRadius: "6px",
                transition: "all 0.3s",
              }}
              onMouseOver={(e) => {
                (e.target as HTMLElement).style.backgroundColor = "transparent";
              }}
              onMouseOut={(e) => {
                (e.target as HTMLElement).style.backgroundColor = "transparent";
              }}
            >
              Help Center
            </a>
          </li>
        </div>
      </div>
    </div>
  );
};

export default Navigation;
